export default __webpack_public_path__ + "static/media/Demise.3ecff42c.jpg";